const activityLogsActionTypes = {
  FETCH_ACTIVITY_LOGS: "FETCH_ACTIVITY_LOGS",
  FETCH_ACTIVITY_LOGS_SUCCESS: "FETCH_ACTIVITY_LOGS_SUCCESS",
  FETCH_ACTIVITY_LOGS_FAILURE: "FETCH_ACTIVITY_LOGS_FAILURE",

  WRITE_ACTIVITY_LOGS: "WRITE_ACTIVITY_LOGS",
  WRITE_ACTIVITY_LOGS_SUCCESS: "WRITE_ACTIVITY_LOGS_SUCCESS",
  WRITE_ACTIVITY_LOGS_FAILURE: "WRITE_ACTIVITY_LOGS_FAILURE",
};

export default activityLogsActionTypes;
